import type {SVGProps} from 'react'
const SvgMagnifyingLarge = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path
      fill="#788492"
      fillRule="evenodd"
      d="M15.292 16a8 8 0 1 1 .707-.707l5.355 5.353a.5.5 0 0 1-.708.708zM17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgMagnifyingLarge
